// @flow
import { resolve } from 'redux-optimist-promise';
import type {
  ChildAttendeeWithInfosType,
  AdultAttendeeWithInfosType,
} from 'Store/booking/booking.selector';
import {
  FETCH_PROPOSALS,
  FETCH_PROPOSALS_BY_ID,
  PREPARE_BE,
} from 'Store/booking/proposals/constants';

type State = {
  adultsAttendees: $ReadOnlyArray<AdultAttendeeWithInfosType>,
  kidsAttendees: $ReadOnlyArray<ChildAttendeeWithInfosType>,
};

const initialState: State = {
  adultsAttendees: [],
  kidsAttendees: [],
};

export function attendeesReducer(state: State = initialState, action: Action<*>): ?State {
  switch (action.type) {
    case resolve(FETCH_PROPOSALS):
    case PREPARE_BE:
    case resolve(FETCH_PROPOSALS_BY_ID): {
      const { adultsAttendees, kidsAttendees } = action.payload;
      return {
        ...state,
        adultsAttendees: adultsAttendees
          ? [...state.adultsAttendees, ...adultsAttendees]
          : state.adultsAttendees,
        kidsAttendees: kidsAttendees
          ? [...state.kidsAttendees, ...kidsAttendees]
          : state.kidsAttendees,
      };
    }
    default:
      return state;
  }
}
